<h1 mat-dialog-title>
  Termin erstellen </h1>
<form [formGroup]="form" (submit)="submit()">
  <div mat-dialog-content>
    <div>
      <div>
        <mat-form-field validationInput>
          <input matInput placeholder="Zeitpunkt" formControlName="date_time" type="datetime-local" />
        </mat-form-field>
      </div>
      <div>
        <label>Dauer</label>
        <mat-slider min="10" max="180" step="5" formControlName="duration" thumbLabel >

        </mat-slider>

      </div>
      <div>
        <mat-form-field validationInput [ngSwitch]="autoCompletState">
          <input matInput placeholder="Kunde" formControlName="site" type="text" [matAutocomplete]="customerAuto" />
          <mat-icon matSuffix class="rotating" *ngSwitchCase="States.LOADING" >refresh</mat-icon>
          <mat-icon matSuffix *ngSwitchCase="States.EMPTY" >not_interested</mat-icon>
          <mat-icon matSuffix *ngSwitchCase="States.ERROR" >error</mat-icon>
        </mat-form-field>
        <mat-autocomplete #customerAuto="matAutocomplete" [displayWith]="displaySite">
          <mat-option *ngFor="let site of filteredSites | async" [value]="site" >
            {{ site.fullName }}
          </mat-option>
        </mat-autocomplete>
      </div>
      <div>
        <mat-radio-group formControlName="on_site">
          <mat-radio-button [value]="true">vor Ort</mat-radio-button>
          <mat-radio-button [value]="false">telefonisch</mat-radio-button>
        </mat-radio-group>
      </div>
    </div>
  </div>
  <div mat-dialog-actions>
    <button type="button" mat-button color="warn" mat-dialog-close>Abbrechen</button>
    <button type="submit" mat-raised-button color="primary" class="pull-right">Erstellen</button>
  </div>
</form>



// WEBPACK FOOTER //
// /home/markush/Projects/fieldsale-wingman-client/src/app/appointment/appointment-create/appointment-create.component.html